function toTemplateStringsArray(message: string): TemplateStringsArray {
  const messageParts = [message];
  Object.defineProperty(messageParts, "raw", { value: [message] });
  return messageParts as unknown as TemplateStringsArray;
}

// Alias $localize to prevent the ivy-extract-loader from trying to statically
// analyze this dynamic call, which is intentionally resolved at runtime.
const runtimeLocalize = $localize;

export function localizeRuntimeById(key: string, fallback: string): string {
  return runtimeLocalize(toTemplateStringsArray(`:@@${key}:${fallback}`));
}
